window.addEventListener("DOMContentLoaded", () => {
    
    const tag = document.querySelectorAll('.tag:not(.disabled)')

    let activeTag = (inputField) => {
        if(inputField){
            inputField.forEach((el) => {

                el.addEventListener("click", (e) => {  el.classList.toggle("active") })

                el.addEventListener('keypress', function (e) {
                    if (e.key === 'Enter') {  el.classList.toggle("active") }
                });

            })
        }
    }
    activeTag(tag)

})